<template>
  <div class="self-select" @click="onClick">
    <el-popover
      v-model="popoverVisible"
      popper-class="self-select-popover"
      ref="pp"
      @after-leave="onPopoverHide"
      @after-enter="onPopoverShow"
      :width="popoverWidth"
      :placement="placement"
      trigger="click"
    >
      <div
        slot="reference"
        class="input-box"
        :class="{ 'input-focus': focus }"
        ref="inputBorderRef"
      >
        <!--<input class="input-border"  readonly ref="inputBorder" @focus="focus = true"/>-->
        <div class="tags" ref="tags">
          <el-tag
            @close="onTagClose(index, item)"
            class="tag"
            type="info"
            :closable="multiple"
            v-for="(item, index) in selectedData"
            :key="index"
          >
            {{ item.label }}
          </el-tag>
          <input
            v-show="canAdd"
            class="input-text"
            :placeholder="placeholder"
            v-model="inputText"
            ref="input"
            @keyup.enter="onEnter"
            @focus="onInputFocus"
            @blur="onInputBlur"
          />
        </div>
        <span class="select-arrow">
          <i class="el-icon-arrow-down" :style="selectArrowStyle"></i>
        </span>
      </div>
      <ul>
        <slot></slot>
        <li v-if="noSearchVal" class="no-data">无数据</li>
      </ul>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: 'self-select',
  props: {
    value: {
      default () {
        if (this.multiple) {
          return []
        } else {
          return ''
        }
      }
    },
    placeholder: String,
    placement: { type: String, default: 'bottom' },
    search: { type: Boolean, default: false },
    formatterValues: { type: Function, default: null },
    canAdd: { type: Boolean, default: true },
    isFlex: { type: Boolean, default: true }, // 垂直居中时，select框高度是上下平均延伸，不是直接向下增加多少高度
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      popoverVisible: false,
      inputText: '',
      noSearchVal: false,
      data: [],
      selectedData: [],
      inputHeight: 0,
      popoverWidth: 100,
      isHeaderOperation: false,
      focus: false
    }
  },
  computed: {
    selectArrowStyle () {
      return this.popoverVisible ? 'transform:rotate(180deg)' : ''
    }
  },
  watch: {
    inputText (v) {
      if (this.search) {
        this.query(v)
      }
    },
    value: {
      handler (val) {
        this.init()
      },
      deep: true
    },
    selectedData: {
      handler () {
        if (this.multiple) {
          this.$emit('input', this.getValues())
        }
      },
      deep: true
    }
  },
  mounted () {
    this.getPopoverRef().$on('onClickItem', this.onClickItem)
    this.getPopoverRef().$on('onClickHeader', this.onClickHeader)
    this.getPopoverRef().$on('initData', this.getData)
    this.setPopoverWidth()
    this.setPopoverTop()
    this.init()
  },
  methods: {
    clearSelectedData () {
      this.selectedData = []
      if (this.getPopoverRef()) {
        this.getPopoverRef().$emit('clearChecked')
      }
    },
    init () {
      let value = this.value
      if (this.multiple) {
        this.$nextTick(() => {
          let newVal = JSON.stringify(value)
          let oldVal = JSON.stringify(this.getValues())
          if (newVal !== oldVal && value) {
            this.selectedData = this.getItemsByValues(value)
          }
          if (!value || value.length === 0) {
            this.getPopoverRef().$emit('clearChecked')
          }
        })
      } else {
        if (!value) {
          this.clearSelectedData()
        } else {
          this.selectedData = [{ value: value, label: value, checked: true }]
        }
      }
    },
    getItemsByValues (values) {
      let data = []
      if (this.formatterValues) {
        values = this.formatterValues(values)
      }
      this.data.forEach(item => {
        if (values.indexOf(item.value) > -1) {
          data.push(item)
        }
      })
      return data
    },
    getValues () {
      let values = []
      this.selectedData.forEach(item => {
        values.push(item.value ? item.value : item.label)
        this.getPopoverRef().$emit('setChecked', {
          value: item.value,
          checked: true
        })
      })
      return values
    },
    getPopoverRef () {
      return this.$refs.pp
    },
    query (str) {
      this.getPopoverRef().$emit('query', str)
      if (str) {
        this.noSearchVal = !this.data.some(item => {
          return item.label && item.label.indexOf(str) > -1
        })
      } else {
        this.noSearchVal = this.data.length === 0 ? true : false
      }
    },
    getData (item) {
      this.data.push(item)
    },
    onClickItem (item) {
      if (item.isSlot) {
        this.$emit('onClick', item)
        return
      }
      if (this.multiple) {
        if (item.checked) {
          this.selectedData.push(item)
        } else {
          let index = this.selectedData.findIndex(obj => {
            return obj.value === item.value
          })
          this.selectedData.splice(index, 1)
        }
      } else {
        if (item.checked) {
          this.selectedData = [item]
        } else {
          this.selectedData = []
        }
        this.getPopoverRef().$emit('clearChecked')
        this.getPopoverRef().$emit('setChecked', {
          value: item.value,
          checked: true
        })
        this.$emit('input', item.label)
      }
    },
    setPopoverPos () {
      if (this.placement === 'bottom') {
        let maxHeight = this.getInputHeight()
        let val = maxHeight - this.inputHeight
        if (this.isFlex) {
          val = val / 2
        }
        val = val === 0 ? 1 : val
        this.getPopoverRef().popperElm.style.marginTop = `${val}px`
      }
    },
    onTagClose (index, item) {
      this.selectedData.splice(index, 1)
      this.$nextTick(() => {
        this.popoverVisible = false
      })
      this.getPopoverRef().$emit('setChecked', {
        value: item.value,
        checked: false
      })
    },
    setFocus () {
      this.$refs.input.focus()
    },
    onClick () {
      this.setFocus()
    },
    getInputHeight () {
      return this.$refs.inputBorderRef.offsetHeight
    },
    onPopoverShow () {
      this.inputHeight = this.getInputHeight()
    },
    onPopoverHide () {
      this.getPopoverRef().popperElm.style.marginTop = '1px'
    },
    setPopoverTop () {
      var dom = this.$refs.tags
      var options = {
        childList: true
      }
      let slef = this
      var observer = new MutationObserver(function () {
        if (slef.popoverVisible) {
          slef.setPopoverPos()
        }
        // slef.$refs.inputBorder.style.height = slef.getInputHeight() + 'px';
      })
      observer.observe(dom, options)
    },
    setPopoverWidth () {
      this.popoverWidth = this.getPopoverRef().$slots.reference[0].elm.offsetWidth
    },
    togglePopover (trueOrFalse) {
      this.popoverVisible = trueOrFalse
      this.setFocus()
      this.focus = trueOrFalse
    },
    onClickHeader () {
      this.isHeaderOperation = true
    },
    onEnter () {
      console.log(this.inputText.trim())
      if (this.inputText.trim()) {
        if (this.multiple) {
          this.selectedData.push({
            value: null,
            label: this.inputText
          })
          this.inputText = ''
        } else {
          this.selectedData = [
            {
              value: null,
              label: this.inputText
            }
          ]
          this.$emit('input', this.inputText)
          this.inputText = ''
        }
      }
    },
    onInputFocus () {
      this.focus = true
    },
    onInputBlur () {
      this.inputText = ''
      window.setTimeout(() => {
        if (!this.popoverVisible) {
          this.focus = false
        }
      }, 200)
    }
  }
}
</script>
<style lang="scss">
@import 'select';
</style>
